module.exports = __webpack_public_path__ + "static/media/fest.90b34bc3.jpg";